<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="dismiss()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <p *ngIf="!requiresReason">
        Are you sure you want to <strong>{{ getActionDisplayText() }}</strong> for order <strong>{{ order?.orderNumber
            || order?._id }}</strong>?
    </p>
    <div *ngIf="requiresReason">
        <p>Are you sure you want to <strong>cancel</strong> order <strong>{{ order?.orderNumber || order?._id
                }}</strong>?</p>
        <div class="form-group">
            <label for="reason" class="form-label">Reason for cancellation <span class="text-danger">*</span></label>
            <textarea id="reason" class="form-control" [(ngModel)]="reason" rows="3" placeholder="Enter reason here..."
                required></textarea>
            <div *ngIf="requiresReason && !reason.trim()" class="text-danger small mt-1">
                Reason is required.
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="dismiss()">Cancel</button>
    <button type="button" class="btn" [ngClass]="actionType === 'cancel' ? 'btn-danger' : 'btn-primary'"
        (click)="confirm()" [disabled]="requiresReason && !reason.trim()">
        {{ actionType === 'cancel' ? 'Submit' : 'Confirm' }}
    </button>
</div>